/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-15 14:49:03
 * @Description  : 全局常量，全大写为索引， 会自动拦截修改
 */
// =================================================================

import { getQueryString } from '@ywxk/util/url';
import { validate } from '@ywxk/util/validate';

// <===================================== 环境常量 ======================================
const DEFINE_VALUE = process.env.config
const { OSS_URL, ENV, PROJECT, FOLDER } = DEFINE_VALUE

// ====================================== 环境常量 =====================================>
// 是否本地服务启动
const IS_LOCAL = validate('isLocal', location.origin)
// 是否离线包资源
const IS_APP_LOCAL = validate('isAppLocal', location.origin)

// 拼接远程资源专用域名,常用于指向远程资源(图片等)
const SERVER_ORIGIN = (IS_LOCAL || IS_APP_LOCAL) ? OSS_URL : location.origin;


// 离线包路径异常,需要重新组装远程路径: file:///var/mobile/Containers/Data/Application/370F9B19-851F-48A2-8FEA-52B242F25752/Library/Caches/WebOfflineZips/oxygen_intimateCeremony/d691eb48251dd7e374188bd0d4a07d95.zip/package.zip/index.html?intimateId=100331&roomid=1112225#/booking
// 区分本地域名和离线包域名指向
const ORIGIN = IS_APP_LOCAL ? OSS_URL : location.origin
const ORIGIN_PATHNAME = ORIGIN + (IS_APP_LOCAL ? `/${ENV}/${PROJECT}/commonality/${FOLDER}/index.html` : location.pathname)
const ORIGIN_PATHNAME_SEARCH = ORIGIN_PATHNAME + location.search

// 项目标准拼接规则
const ORIGIN_ENV_PROJECT = `${ORIGIN}/${ENV}/${PROJECT}`
const SERVER_ORIGIN_ENV_PROJECT = `${SERVER_ORIGIN}/${ENV}/${PROJECT}`
const ORIGIN_ENV_PROJECT_ASSETS = `${SERVER_ORIGIN_ENV_PROJECT}/commonality/assets`

const target = Object.assign({
  IS_DEBUG: Number(getQueryString('debug')) === 1,
  IS_FORMAT: Number(getQueryString('format')) === 1,
  ACT_ID: Number(getQueryString('actId')) || '',
  PC_BROWSER_ID: getQueryString('pcBrowserId') || '',
  IS_LOCAL,
  IS_APP_LOCAL,

  SERVER_ORIGIN,
  ORIGIN,
  ORIGIN_ENV_PROJECT,
  SERVER_ORIGIN_ENV_PROJECT,
  ORIGIN_PATHNAME,
  ORIGIN_PATHNAME_SEARCH,
  ORIGIN_ENV_PROJECT_ASSETS
}, DEFINE_VALUE)

const constConf = new Proxy(target, {
  set(_, propKey) {
    console.log(`全局变量${String(propKey)}不支持修改，建议自行业务维护！`)
    return true
  },
})

export { constConf }
declare namespace constConf { }
